import eventBus from './../core.js';

const eventName = 'handleAddToCart';

const subscribe = callback => {
    return eventBus.subscribe(eventName, callback);
};

const broadcast = data => {
    return eventBus.broadcast(eventName, data);
};

export default {
    subscribe,
    broadcast,
};
